import setFolderViewState from '../actions/setFolderViewState';
import MailFolderNodeViewState from '../store/schema/MailFolderNodeViewState';
import { default as folderTreeViewStateStore } from '../store/store';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { MailSortHelper, SortBy } from 'owa-mail-list-store';
import { ObservableMap } from 'mobx';
import { select } from 'satcheljs/lib/legacy';

export interface GetFolderViewStateFromIdState {
    folderNodeViewStates: ObservableMap<string, MailFolderNodeViewState>;
}

export default select({
    folderNodeViewStates: () => folderTreeViewStateStore.folderNodeViewStates,
})(function getFolderViewStateFromId(
    folderId: string,
    state?: GetFolderViewStateFromIdState
): MailFolderNodeViewState {
    if (!state.folderNodeViewStates.has(folderId)) {
        const defaultSortBy: SortBy = MailSortHelper.getDefaultSortBy();
        setFolderViewState(folderId, {
            isExpanded: false,
            sortColumn: defaultSortBy.sortColumn,
            sortOrder: defaultSortBy.sortDirection,
            drag: createDragViewState(),
            drop: createDropViewState(),
        });
    }
    return state.folderNodeViewStates.get(folderId);
});
